import gql from "graphql-tag";
const FilterableIndicatorValuesQuery = gql`
  query FilterableIndicatorValues($objectId: ID!, $context: ScreenerContextInput!) {
    filterableIndicatorValues(objectId: $objectId, context: $context) {
      ... on ScreenerFilterableIndicatorOptionsList {
        objectId
        options {
          count
          label
          value
        }
      }
    }
  }
`;
export default FilterableIndicatorValuesQuery;
